import { ReactNode } from 'react'
import { usePermissions } from '@/hooks/usePermissions'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { AlertCircle } from 'lucide-react'

interface PermissionGateProps {
  children: ReactNode
  roles?: string | string[]
  permissions?: string | string[]
  fallback?: ReactNode
  showError?: boolean
}

export function PermissionGate({
  children,
  roles,
  permissions,
  fallback,
  showError = false,
}: PermissionGateProps) {
  const { hasRole, hasPermission } = usePermissions()

  let hasAccess = true

  if (roles) {
    hasAccess = hasAccess && hasRole(roles)
  }

  if (permissions) {
    const perms = Array.isArray(permissions) ? permissions : [permissions]
    hasAccess = hasAccess && perms.every((p) => hasPermission(p))
  }

  if (!hasAccess) {
    if (fallback) return <>{fallback}</>

    if (showError) {
      return (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            You don't have permission to access this resource.
          </AlertDescription>
        </Alert>
      )
    }

    return null
  }

  return <>{children}</>
}
